export default {
    genToken(id, ownerid) {
        return new Promise((resolve, reject) => {
            let route = window.sellsyapp.$router.resolve({ name: 'legacy.api.token.gen', params: { 'id': id, 'owner_id': ownerid } })
            window.SellsyJS.WebServiceCaller.post(route.href, {}, {}, resolve, reject)
        }).then(response => { if (response.error) { throw response } return response })
    },
    regenToken(type, id) {
        return new Promise((resolve, reject) => {
            let route = window.sellsyapp.$router.resolve({ name: 'legacy.api.token.regen', params: { 'id': id, 'type': type } })
            window.SellsyJS.WebServiceCaller.post(route.href, {}, {}, resolve, reject)
        }).then(response => { if (response.error) { throw response } return response })
    }
}